import HeroCard from "./HeroCard";
import { useLens } from "../lens/LensProvider";

export default function HomeDiscovery() {
  const { notice } = useLens();
  return <>
    <div className="home-heroes">
      <HeroCard className="discovery-feature" size="lg" photo="hornet_sunset" focus="100% 50%"
        title={<>Earn your wings.<br /><span className="hero-accent">Master your craft.</span></>}
        body="Track your DCS flying and earn proficiency awards across aircraft, weapons and operations."
        cta={{ label: "Explore proficiencies", href: "#/proficiencies" }} />
      <div className="home-hero-side">
        <HeroCard className="discovery-feature discovery-secondary" size="sm" photo="f15" focus="50% 35%" kicker="Achievements"
          title="Make a sortie memorable." cta={{ label: "Explore achievements", href: "#/achievements" }} />
        <HeroCard className="discovery-feature" size="sm" photo="lso" focus="50% 45%" kicker="Greenie Board"
          title="Every trap, graded." cta={{ label: "See the board", href: "#/greenie_board" }} />
      </div>
    </div>
    {notice && <p role="status" className="discovery-notice">{notice}</p>}
  </>;
}
